import React from "react";
import Testimonials from "../home/Testimonials";

const ProspectingTestimonials = () => {
  return <Testimonials />;
};

export default ProspectingTestimonials;
